<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive">
    </router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // // 动态决定哪些组件需要被缓存
      // includedComponents:[]
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: "PingFang SC","Helvetica Neue",Helvetica,"Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
.container{
  width: 1280px;
  margin: 0 auto;
}
// 共用带背景的标题
.h2-title{
  font-size: 18px;
  color: #009FFC;
  line-height: 40px;
  font-weight: 500;
  padding: 30px 0 0 10px;
  background: url('assets/title_bg.png') no-repeat top left;
  background-size: 153px;
}
.h2-btitle{
  color: #fff;
  background: url('assets/title_bg1.png') no-repeat top left;
  background-size: 153px;
}
@media only screen and (max-width: 1280px) {
  .container {
    width: 90%;
  }
}
@media only screen and (max-width: 767px){
  .h2-title{
    padding-top: 10px;
    font-size: 18px;
    background-size: 100px;
  }
}
</style>
